import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame } from '@react-three/fiber'
import { useLoader } from '@react-three/fiber'
import { useTexture } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { GlitchPass } from './GlitchPass'
import { MeshBasicMaterial } from 'three';
import { MeshStandardMaterial } from 'three';
import { Vector3 } from 'three';

extend({ EffectComposer, RenderPass, UnrealBloomPass, GlitchPass });


function Effect({ down }) {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current.render(), 1)
  return (
    <>
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <unrealBloomPass attachArray="passes" args={[aspect, 1, 1.2, 0]} />
      <glitchPass attachArray="passes" renderToScreen factor={down ? 0.5 : 0} />
    </effectComposer>
    </>
  )
}

function Model({ ...props }) {
  const [model, set] = useState()
  const [mixer, set2] = useState()
  useEffect(() => {
    void new GLTFLoader().load("./petal.glb", (gltf) => {
      gltf.scene.children[0].children[1].material = new THREE.MeshStandardMaterial({color: 'purple'})
      if (gltf.animations.length) {
          set2(new THREE.AnimationMixer(gltf.scene));
      }
      set(gltf);
    });
    
    
  }, [])

  model?.animations.forEach(clip => {
      const action = mixer?.clipAction(clip);
      action?.startAt(props.offset / 2 + Math.random() * 0.1);
      action?.play();
  });

  let inc = 0;
  useFrame((state, delta) => {

    mixer?.update(delta / 2);
    if(model && viewerIsOwner && colorama)
    {
      var color = new THREE.Color();
      color.setHSL( Math.abs(Math.sin(inc)), 1, 0.5 );
      model.scene.children[0].children[1].material.color = color;
      inc += 0.01;
    }
    else if(model)
    {
      model.scene.children[0].children[1].material.color.set(props.color ? props.color : 'purple');
    }
  })

  return model ? <primitive object={model.scene} {...props} /> : null
}

function Stem() {
  const { scene, camera } = useThree();
  const ref = useRef();
  let points = [new THREE.Vector3(0,0,0)];

  for(let i=0; i < 3; i++)
  {
    points.push(new THREE.Vector3(Math.random() , i, Math.random()))
  }
  points.push(new THREE.Vector3(0,3,0));
  points.push(new THREE.Vector3(0,4,0));
  let curve = new THREE.CatmullRomCurve3(points);

  
  useFrame(({clock}) => {
    camera.position.set(Math.sin(clock.getElapsedTime()) * 2, 
                        (Math.sin(clock.getElapsedTime())+0.9)*2 + curve.getPoint(Math.min(clock.getElapsedTime() / 10, 1)).y, 
                        Math.cos(clock.getElapsedTime()) * 2);
    camera.lookAt(curve.getPoint(Math.min(clock.getElapsedTime() / 10 + 0.1, 1)))
  });



  return (<>
    {
      points.map((point,i) => { return i<=3 ? <Model rotation={[0,i * Math.PI * 2 / 10,0]} position={point} offset={i} key={i} color={"green"}/> : null})
    }
  <mesh>
    <tubeGeometry args={[curve, 70, 0.05, 50, false]} />
    <meshBasicMaterial color={'green'} />
  </mesh>
  </>);
}


const params = new URLSearchParams(window.location.search);
const viewer = params.get('viewer');
let viewerIsOwner = false;
let objkt = parseInt(params.get("objkt"), 10);

const query = `
query Objkt($id: bigint!) {
  hic_et_nunc_token_by_pk(id: $id) {
    token_holders(where: {quantity: {_gt: "0"}}, order_by: {id: asc}) {
      quantity
      holder {
        address
        name
      }
    }
  }
}
`;


async function fetchGraphQL(operationsDoc, operationName, variables) {
  const result = await fetch(
    "https://api.hicdex.com/v1/graphql",
    {
      method: "POST",
      body: JSON.stringify({
        query: operationsDoc,
        variables: variables,
        operationName: operationName
      })
    }
  );

  return await result.json();
}

async function doFetch() {
  if(!objkt) return;
  const { errors, data } = await fetchGraphQL(query, "Objkt", {"id":objkt});
  if (errors) {
    console.error(errors);
  }
  else 
  {
    const result = data.hic_et_nunc_token_by_pk;
    console.log({ result });
    return result;
  }
}

function checkViewerIsOwner(data) {
  if(!data || !data.token_holders) return;
  if (data.token_holders.some((e) => e.holder.address === viewer)) {
    console.log(`viewer IS owner`);
    viewerIsOwner = true;
  } else {
    console.log(`viewer is NOT owner`);
  }
  //console.log({ OBJKT: data });
}

doFetch(objkt)
      .then((data) => checkViewerIsOwner(data))
// let data = doFetch();

let models = [], colorama = false;
for(let i=0; i < 10; i++)
{
  models[i] = i;
}



function App() {
  const [down, set] = useState(false);


  return (
    <div id="wrapper" onMouseDown={() => {
      if(!viewerIsOwner) set(true);
      else colorama = true;
    }} onMouseUp={() => {set(false); colorama = false;}}>
  <Canvas >
  {/* <color attach="background" args={"#050105"} /> */}
    <Effect down={down} />
      <ambientLight intensity = {0.1} />
      <pointLight position={[0,4.1,0]} intensity={3}/>
      <pointLight position={[0,5,0]} intensity={1} color={'orange'}/>
      
      <mesh  position={[0,4,0]}>
        <sphereGeometry args={[0.05,16,16]} />
        <meshStandardMaterial color={'white'} />
      </mesh>

      <Suspense fallback={<h1>Loading...</h1>}>
        <Stem />
        {
          models.map((i) => { return <Model rotation={[0,i * Math.PI * 2 / 10,0]} position={[0,4,0]} offset={i} key={i}/>})
        }
        {
          models.map((i) => { return <Model rotation={[0,i * Math.PI * 2 / 10 + Math.PI,0]} position={[0,4,0]} offset={i+1} key={i}/>})
        }
        {
          models.map((i) => { return <Model rotation={[0,i * Math.PI * 2 / 10 - Math.PI / 2,0]} position={[0,4,0]} offset={i-1} key={i}/>})
        }
      </Suspense>
    {/* <OrbitControls />
    <Stats /> */}
  </Canvas>
  </div>
  );
}

export default App;
